class BaseSerializer {
    /**
     * The ol.source.Source class that this serializer will serialize.
     *
     * @type {ol.source.Source}
     * @protected
     */

    constructor() {
        this.sourceCls = null;
    }

    /**
     * Serializes the passed source and layer into an object that the
     * Print Servlet understands.
     *
     * @param {ol.layer.Layer} layer The layer to serialize.
     * @param {ol.source.Source} source The source of the layer to
     *    serialize.
     * @param {Number} viewRes The resolution of the mapview.
     * @return {Object} A serialized representation of source and layer.
     */
    serialize() {
        this.raiseException('This method must be overriden by subclasses.')
        return null;
    }

    getSourceCls() {
        return this.sourceCls;
    }

    /**
     * Given a concrete `ol.source.Source` instance, this method checks if
     * the non-abstract subclass is capable of serializing the source. Will
     * throw an exception if the source isn't valid for the serializer.
     *
     * @param {ol.source.Source} source The source to test.
     * @protected
     */
    validateSource(source) {
        let valid = source instanceof this.sourceCls;
        if (!valid) {
            this.raiseException('Cannot serialize this source with this serializer')
        }
        return valid;
    }

    raiseException(error) {
        console.error(error);
        throw new Error(error);
    }

    getGeomProperty() {
        return '_geom';
    }
}

export default BaseSerializer;